import { render, staticRenderFns } from "./order-pane1.vue?vue&type=template&id=4080906a&scoped=true"
import script from "./order-pane1.vue?vue&type=script&lang=ts"
export * from "./order-pane1.vue?vue&type=script&lang=ts"
import style0 from "./order-pane1.vue?vue&type=style&index=0&id=4080906a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080906a",
  null
  
)

export default component.exports